import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=2ac33288&scoped=true&"
import script from "./mobileFooter.vue?vue&type=script&lang=js&"
export * from "./mobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&id=2ac33288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac33288",
  null
  
)

export default component.exports